import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=6bfebd08&scoped=true"
import script from "./ContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactInfo.vue?vue&type=script&lang=js"
import style0 from "./ContactInfo.vue?vue&type=style&index=0&id=6bfebd08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfebd08",
  null
  
)

export default component.exports